import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Field, inputCls } from "@/components/common";
import { AuthCard } from "@/components/Brand";
import { Button } from "@/components/ui/button";

export default function ForgotPassword() {
  const [email, setEmail] = useState(localStorage.getItem("neec_remember_email") || "");
  const [sent, setSent] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { const { data } = await api.post("/auth/forgot-password", { email }); setSent(data.message); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <AuthCard testId="forgot-password-page">
      <h1 className="text-3xl font-bold text-slate-900">Forgot your password?</h1>
      <p className="text-sm text-slate-500 mb-6">Enter the email for your NEEC Service account and we'll send you a reset link.</p>
      {sent ? (
        <div className="space-y-4">
          <p className="text-sm text-emerald-800 bg-emerald-50 rounded-lg px-3 py-3" data-testid="forgot-success">{sent}</p>
          <p className="text-xs text-slate-500">The link expires in 60 minutes. Check your spam folder if you don't see it.</p>
          <Button asChild className="w-full h-12 btn-orange text-base"><Link to="/login" data-testid="back-to-login">Back to sign in</Link></Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="Email"><input data-testid="forgot-email-input" type="email" name="username" inputMode="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" autoCapitalize="none" spellCheck={false} /></Field>
          {err && <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2" data-testid="forgot-error">{err}</p>}
          <Button type="submit" disabled={busy} className="w-full h-12 btn-orange text-base" data-testid="forgot-submit">{busy ? "Sending..." : "Send reset link"}</Button>
          <p className="text-center text-sm"><Link to="/login" className="font-semibold text-slate-600 hover:text-slate-900" data-testid="back-to-login">Back to sign in</Link></p>
        </form>
      )}
    </AuthCard>
  );
}
